import { useEffect, useState } from "react"
import axios, { AxiosResponse } from "axios"
import { getToken } from "@/helpers/storage"
import { Department } from "@/types"
import { useMutation, useQuery } from "@tanstack/react-query"
import {
  deleteDepartment,
  getDepartments,
  getOrgDepartments,
  getOrgDepartmentsActive,
  updateDepartmentStatus,
} from "@/service/_apiService"

export const useOrgDepartments = () => {
  const [departments, setDepartments] = useState<Array<Department>>([])

  useEffect(() => {
    const token = getToken()
    axios(`${import.meta.env.VITE_APP_API_ENDPOINT}/org/departments`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    })
      .then((res: AxiosResponse) => {
        const { data, status } = res
        if (status === 200) {
          setDepartments(data.data.filter((d: Department) => d.active))
        } else {
          console.error("There was an error fetching departments 😤")
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  return [departments]
}

export const useGetDepartments = () => {
  return useQuery({
    queryKey: ["getDepartments"],
    queryFn: getDepartments,
    refetchOnWindowFocus: false,
  })
}

export const useGetOrgDepartmentsActive = () => {
  return useQuery({
    queryKey: ["getOrgDepartmentsActive"],
    queryFn: getOrgDepartmentsActive,
    refetchOnWindowFocus: false,
  })
}
export const useGetOrgDepartments = () => {
  return useQuery({
    queryKey: ["getOrgDepartments"],
    queryFn: getOrgDepartments,
    refetchOnWindowFocus: false,
  })
}

export const useDeleteDepartment = () => {
  return useMutation({
    mutationKey: ["deleteDepartment"],
    mutationFn: deleteDepartment,
    onSuccess: (data) => {
      console.log("departament eliminado con exito", data)
    },
    onError: (error) => {
      console.error("Error al eliminar department:", error)
    },
  })
}

export const useUpdateDepartmentStatus = () => {
  return useMutation({
    mutationKey: ["updateDepartmentStatus"],
    mutationFn: updateDepartmentStatus,
    onSuccess: (data) => {
      if (data.success) {
        console.log("Departamento actualizado con éxito", data)
      } else {
        console.warn("La actualización del departamento no fue exitosa", data)
      }
    },
    onError: (error) => {
      console.error("Error al actualizar el departamento:", error)
    },
  })
}
